/* eslint-disable @typescript-eslint/explicit-function-return-type */
import React from 'react'
import { CouponAction } from '@/components'

import './index.scss'
import NOTICE from './images/notice.png'

const CouponItem = props => {
  const { data = {}, merchantInfo = true, extraItemClass = '', extraValueClass = '', btnText = '领取', gettedBtnText = '去使用', btnExtraClass = 'button', comUser = 'receiveCoupon', gettedBtnClass = '', isActive = false, showLoading, children } = props
  const { id, type, value, condition_amount_text, name, merchant_text, path, is_receive } = data

  const getDiscount = () => {
    let res = <>
      <span className="icon">¥</span>
      <span>{value}</span>
    </>
    if (type === 'discount') {
      res = <>
        <span>{value}</span>
        <span className="icon discount">折</span>
      </>
    }
    return res
  }

  return (
    <div className={`coupon-item ${extraItemClass}`}>
      <div className={`coupon-item-value ${extraValueClass}`} >
        <div className="coupon-item-value-discount">
          {getDiscount()}
        </div>
        <div className="coupon-item-value-price">{condition_amount_text}</div>
      </div>

      <div className="coupon-item-info">
        <div className="title">{name}</div>
        {
          (merchantInfo && merchant_text) && <div className="disc">
            <>
              <img src={NOTICE} />
              <div className="disc-text">
                <div className="disc-text-content">
                  {merchant_text}
                </div>
              </div>
            </>
          </div>
        }
      </div>

      <div className="button-container">
        <CouponAction appPath={path}
            btnExtraClass={btnExtraClass}
            btnText={btnText}
            children={children}
            comUser={comUser}
            couponId={id}
            gettedBtnClass={gettedBtnClass}
            gettedBtnText={gettedBtnText}
            isActive={isActive}
            isReceive={is_receive}
            openUrl={path}
            showLoading={showLoading} />
      </div>
    </div>
  )
}
export default CouponItem
